import { toast } from 'sonner';
import { API_ENDPOINTS, HTTP_METHODS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

export interface Department {
  id: number;
  name: string;
  code?: string;
  isActive: boolean;
  branchId?: number;
}

export interface DepartmentCreateRequest {
  name: string;
  code: string;
  isActive?: boolean;
  branchId?: number;
}

class DepartmentApiService extends BaseApiService {
  async getActiveByBranch(branchId: number): Promise<Department[]> {
    if (!branchId) return [];
    try {
      const url = API_ENDPOINTS.DEPARTMENTS.BY_BRANCH_ACTIVE(branchId);
      const response = await this.makeRequest<ApiResponse<Department[]>>(url, { method: HTTP_METHODS.GET });
      if (response.success) return response.data;
      throw new Error(response.message || 'Failed to fetch departments');
    } catch (error) {
      // console.error('Error fetching departments by branch:', error);
      toast.error('Failed to load departments');
      throw error;
    }
  }

  async createDepartment(departmentData: DepartmentCreateRequest): Promise<Department> {
    try {
      const response = await this.makeRequest<ApiResponse<Department>>(
        '/inventory/departments',
        {
          method: HTTP_METHODS.POST,
          body: JSON.stringify(departmentData)
        }
      );
      if (response.success) {
        toast.success('Department created successfully');
        return response.data;
      }
      throw new Error(response.message || 'Failed to create department');
    } catch (error) {
      // console.error('Error creating department:', error);
      toast.error('Failed to create department');
      throw error;
    }
  }
}

export const departmentApiService = new DepartmentApiService();


